import React, { FC } from 'react';
import { Page, StyleSheet, Text } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import { IIndividualStates } from '../../../../services/individualReport';
import { THEME as theme } from '../../../../styles/theme';
import Legend from '../../components/Legend/Legend';
import PageCount from '../../components/PageCount/PageCount';
import PageSection from '../../components/PageSection/PageSection';
import SummaryList from '../../components/SummaryList/SummaryList';

const TOPICS_PER_PAGE = 10;

const styles = StyleSheet.create({
  page: {
    position: 'relative',
    fontFamily: 'Roboto-Regular',
    backgroundColor: theme.colors.neutral.secondary,
  },
});

interface IPredictiveStatesPage {
  individualStates: IIndividualStates;
  mode: 'results' | 'group';
}

const PredictiveStatesPage: FC<IPredictiveStatesPage> = ({ individualStates, mode }) => {
  const { t } = useTranslation();

  const { description, topics, group_description } = individualStates;

  const parsedDescription = description.replaceAll('<br>', '\n');
  const parsedGroupDescription = group_description.replaceAll('<br>', '\n');

  const topicsPerPage = [topics.slice(0, TOPICS_PER_PAGE), topics.slice(TOPICS_PER_PAGE)];

  return (
    <>
      {topicsPerPage.map((topics, index) =>
        topics.length > 0 ? (
          <Page
            key={index}
            id="perceived-work-environment"
            orientation="portrait"
            size="A4"
            style={styles.page}
            wrap={false}
          >
            <PageSection title={t('results.report.pdf.sections.predictiveStates')}>
              <Text>{mode === 'group' ? parsedGroupDescription : parsedDescription}</Text>
              <Legend />
              <SummaryList data={topics} type="topics" {...{ mode }} />
            </PageSection>
            <PageCount />
          </Page>
        ) : null
      )}
    </>
  );
};

export default PredictiveStatesPage;
